import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { OrgBasedCandidateForm } from 'src/app/constants/org-forms-constants/org-based-forms-model';
import { ValidationConstants as validationConstants } from '../../../constants/validation-constants';
import { endDateValidator, FilesRequiredValidator } from './customasyncvalidators';


@Injectable()
export class CandidateFormsUtil {

    constructor(private formBuilder: FormBuilder) { }

    // initialize form
    initializeForm() {
        return this.formBuilder.group({
            id: new FormControl(''), // Used only for VIEW 
            appid: new FormControl(''),
            salutation: new FormControl(''),
            firstname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            middlename: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            lastname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            mobino: new FormControl(''),
            email: new FormControl('', [Validators.email]),
            keyskill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            profilepicdata: new FormControl(''),
            createdby: new FormControl(''),
            createdon: new FormControl(''),
            modifiedby: new FormControl(''),
            status: new FormControl(''),
            files: new FormControl(''),
            byteafiles: new FormControl('', [FilesRequiredValidator('byteafiles')]),
            // summary: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(500)]),
            // remarks: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(500)]),
            funarea: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            subfunarea: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            totexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.max(45)]),
            relexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.max(45)]),
            currentctc: new FormGroup({
                value: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
                type: new FormControl(''),
            }),
            expctc: new FormGroup({
                value: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
                type: new FormControl(''),
            }),
            // reasonchange: new FormControl(''),
            noticeperiod: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(180), Validators.min(0), Validators.maxLength(3)]),
            joindur: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(180), Validators.min(0), Validators.maxLength(3)]),
            source: new FormControl('Career Website'),
            sourcedetails: new FormControl('Career Website', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            currentemployer: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            highesteducation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(70)]),
            specialization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            yearofpassing: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4),Validators.minLength(4)]),
            prefloc: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            gender: new FormControl('Unavailable'),
            dob: new FormControl(''),
            age: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.min(1), Validators.max(99)]),
            nationality: new FormControl(''),
            decworkprev: new FormControl(''),
            decrelwork: new FormControl(''),
            decmedi: new FormControl(''),
            declaration: new FormGroup({
                workedpreviouslydetails: new FormGroup({
                    dept_company: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    ctc: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(8)]),
                    ctctype: new FormControl(''),
                    dateofrelieving: new FormControl(''),
                    reason: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                    supervisor_empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    supervisor_designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_email: new FormControl('', [Validators.email]),
                    supervisor_dialcode: new FormControl(''),
                    supervisor_mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
                    supervisor_mobino: new FormControl('')
                }),
                // relative
                relativeworkingdetails: this.formBuilder.array([]), // FormArray
                // medical 
                medicalailmentsdetails: new FormGroup({
                    description: new FormControl('', [Validators.maxLength(250)])
                }),
            }),
            curaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            permaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            curaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            permaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            curtcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            permcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            permcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curtstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            permstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]),
            permpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]),
            emecontactname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            emerel: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            emenum: new FormControl(''),
            ethnicity: new FormControl(''),
            militaryveteran: new FormControl(''),
            differentlyabled: new FormControl(''),
            resumeuploaded: new FormControl(''),
            profilepicuploaded: new FormControl(''),
            candidatedata: new FormGroup({
                // experience
                experience: this.formBuilder.array([]), // FormArray
                //education
                education: this.formBuilder.array([]), // FormArray
                //skills
                skills: this.formBuilder.array([]), // FormArray
            }),
            flag: new FormControl(''),
            orgid: new FormControl(''),
            resumeuploadkey: new FormControl(null),
            profilepicuploadkey: new FormControl(null),
            profilecompleted: new FormControl(true),
            reqid: new FormControl(null),
            isupdated: new FormControl(null),
            atscandid: new FormControl(null),
            templocation: new FormControl(),
            dialcode: new FormControl(),
            emedialcode: new FormControl(),
            mobilenumber: new FormControl(null, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
            ememobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
            currentlyemployed: new FormControl(true),
            maritalstatus: new FormControl(''),
            altdialcode: new FormControl(''),
            altmobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
            altermobino: new FormControl(''),
            altemail: new FormControl('', [Validators.email]),
            sameascurrentaddress: new FormControl(''),

        });
    }

    // update form
    updateDynamicValidation(orgBasedCandidateFormsJson, candidateCreateForm: FormGroup) {
        //salutation 
        if (orgBasedCandidateFormsJson.salutationFieldIsRequired) {
            candidateCreateForm.get('salutation').setValidators([Validators.required]);
        }
        // firstname
        if (orgBasedCandidateFormsJson.firstnameFieldIsRequired) {
            candidateCreateForm.get('firstname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
        }
        // middlename
        if (orgBasedCandidateFormsJson.middlenameFieldIsRequired) {
            candidateCreateForm.get('middlename').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
        }
        // lastname
        if (orgBasedCandidateFormsJson.lastnameFieldIsRequired) {
            candidateCreateForm.get('lastname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
        }
        // mobino 
        if (orgBasedCandidateFormsJson.mobinoFieldIsRequired) {
            candidateCreateForm.get('mobino').setValidators([Validators.required]);
        }
        // email
        if (orgBasedCandidateFormsJson.emailFieldIsRequired) {
            candidateCreateForm.get('email').setValidators([Validators.required, Validators.email]);
        }
        // keyskill
        if (orgBasedCandidateFormsJson.keyskillFieldIsRequired) {
            candidateCreateForm.get('keyskill').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
        }
        // status
        if (orgBasedCandidateFormsJson.statusFieldIsRequired) {
            candidateCreateForm.get('status').setValidators([Validators.required]);
        }
        // summary
        // if (orgBasedCandidateFormsJson.summaryFieldIsRequired) {
        //     candidateCreateForm.get('summary').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(500)]);
        // }
        // remarks
        // if (orgBasedCandidateFormsJson.remarksFieldIsRequired) {
        //     candidateCreateForm.get('remarks').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(500)]);
        // }
        // funarea
        if (orgBasedCandidateFormsJson.funareaFieldIsRequired) {
            candidateCreateForm.get('funarea').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
        }
        // subfunarea
        if (orgBasedCandidateFormsJson.subfunareaFieldIsRequired) {
            candidateCreateForm.get('subfunarea').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
        }
        // totexp
        if (orgBasedCandidateFormsJson.totexpFieldIsRequired) {
            candidateCreateForm.get('totexp').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.max(45)]);
        }
        // relexp
        if (orgBasedCandidateFormsJson.relexpFieldIsRequired) {
            candidateCreateForm.get('relexp').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.max(45)]);
        }
        // currentctc
        if (orgBasedCandidateFormsJson.currentctcFieldIsRequired) {
            candidateCreateForm.get('currentctc').get('value').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]);
            candidateCreateForm.get('currentctc').get('type').setValidators([Validators.required]);
        }
        // expctc
        if (orgBasedCandidateFormsJson.expctcFieldIsRequired) {
            candidateCreateForm.get('expctc').get('value').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]);
            candidateCreateForm.get('expctc').get('type').setValidators([Validators.required]);
        }
        // reasonchange
        // if (orgBasedCandidateFormsJson.reasonchangeFieldIsRequired) {
        //     candidateCreateForm.get('reasonchange').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
        // }
        // noticeperiod
        if (orgBasedCandidateFormsJson.noticeperiodFieldIsRequired) {
            candidateCreateForm.get('noticeperiod').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(180), Validators.min(0), Validators.maxLength(3)]);
        }
        // joindur
        if (orgBasedCandidateFormsJson.joindurFieldIsRequired) {
            candidateCreateForm.get('joindur').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(180), Validators.min(0), Validators.maxLength(3)]);
        }
        // source
        if (orgBasedCandidateFormsJson.sourceFieldIsRequired) {
            candidateCreateForm.get('source').setValidators([Validators.required]);
        }
        // sourcedetails
        if (orgBasedCandidateFormsJson.sourcedetailsFieldIsRequired) {
            candidateCreateForm.get('sourcedetails').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
        }
        // designation
        if (orgBasedCandidateFormsJson.designationFieldIsRequired) {
            candidateCreateForm.get('designation').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
        }
        // prefloc
        if (orgBasedCandidateFormsJson.preflocFieldIsRequired) {
            candidateCreateForm.get('prefloc').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
        }
        // gender
        if (orgBasedCandidateFormsJson.genderFieldIsRequired) {
            candidateCreateForm.get('gender').setValidators([Validators.required]);
        }
        // dob
        if (orgBasedCandidateFormsJson.dobFieldIsRequired) {
            candidateCreateForm.get('dob').setValidators([Validators.required]);
        }
        // nationality
        if (orgBasedCandidateFormsJson.nationalityFieldIsRequired) {
            candidateCreateForm.get('nationality').setValidators([Validators.required]);
        }
        //military vetran
        if (orgBasedCandidateFormsJson.militaryveteranFieldIsRequired) {
            candidateCreateForm.get('militaryveteran').setValidators([Validators.required]);
        }
        //ethnicity
        if (orgBasedCandidateFormsJson.ethnicityFieldIsRequired) {
            candidateCreateForm.get('ethnicity').setValidators([Validators.required]);
        }
        //differently abled
        if (orgBasedCandidateFormsJson.differentlyabledFieldIsRequired) {
            candidateCreateForm.get('differentlyabled').setValidators([Validators.required]);
        }
        // decworkprev
        if (orgBasedCandidateFormsJson.decworkprevFieldIsRequired) {
            candidateCreateForm.get('decworkprev').setValidators([Validators.required]);
        }
        // decrelwork
        if (orgBasedCandidateFormsJson.decrelworkFieldIsRequired) {
            candidateCreateForm.get('decrelwork').setValidators([Validators.required]);
        }
        // decmedi
        if (orgBasedCandidateFormsJson.decmediFieldIsRequired) {
            candidateCreateForm.get('decmedi').setValidators([Validators.required]);
        }
        // curaddline1
        if (orgBasedCandidateFormsJson.curaddline1FieldIsRequired) {
            candidateCreateForm.get('curaddline1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
        }
        // permaddline1
        if (orgBasedCandidateFormsJson.permaddline1FieldIsRequired) {
            candidateCreateForm.get('permaddline1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
        }
        // curaddline2
        if (orgBasedCandidateFormsJson.curaddline2FieldIsRequired) {
            candidateCreateForm.get('curaddline2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
        }
        // permaddline2
        if (orgBasedCandidateFormsJson.permaddline2FieldIsRequired) {
            candidateCreateForm.get('permaddline2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
        }
        // curtcity
        if (orgBasedCandidateFormsJson.curtcityFieldIsRequired) {
            candidateCreateForm.get('curtcity').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
        }
        // curcountry
        if (orgBasedCandidateFormsJson.curcountryFieldIsRequired) {
            candidateCreateForm.get('curcountry').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
        }
        // permcountry
        if (orgBasedCandidateFormsJson.permcountryFieldIsRequired) {
            candidateCreateForm.get('permcountry').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
        }
        // permcity
        if (orgBasedCandidateFormsJson.permcityFieldIsRequired) {
            candidateCreateForm.get('permcity').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
        }
        // curtstate
        if (orgBasedCandidateFormsJson.curtstateFieldIsRequired) {
            candidateCreateForm.get('curtstate').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
        }
        // permstate
        if (orgBasedCandidateFormsJson.permstateFieldIsRequired) {
            candidateCreateForm.get('permstate').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
        }
        // curpin
        if (orgBasedCandidateFormsJson.curpinFieldIsRequired) {
            candidateCreateForm.get('curpin').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.minLength(4), Validators.maxLength(10)]);
        }
        // permpin
        if (orgBasedCandidateFormsJson.permpinFieldIsRequired) {
            candidateCreateForm.get('permpin').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.minLength(4), Validators.maxLength(10)]);
        }
        // emecontactname
        if (orgBasedCandidateFormsJson.emecontactnameFieldIsRequired) {
            candidateCreateForm.get('emecontactname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
        }
        // emerel
        if (orgBasedCandidateFormsJson.emerelFieldIsRequired) {
            candidateCreateForm.get('emerel').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
        }
        // emenum
        if (orgBasedCandidateFormsJson.emenumFieldIsRequired) {
            candidateCreateForm.get('emenum').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]);
        }
        // dialcode
        if (orgBasedCandidateFormsJson.mobinoFieldIsRequired) {
            candidateCreateForm.get('dialcode').setValidators([Validators.required]);
        }
        // flag
        if (orgBasedCandidateFormsJson.flagFieldIsRequired) {
            candidateCreateForm.get('flag').setValidators([Validators.required]);
        }
        candidateCreateForm.get('byteafiles').setValidators([FilesRequiredValidator('byteafiles')]);

        // Marital status
        if (orgBasedCandidateFormsJson.maritalstatusFieldIsRequired) {
            candidateCreateForm.get('maritalstatus').setValidators([Validators.required]);
        }

        // altemail
        if (orgBasedCandidateFormsJson.altemailFieldIsRequired) {
            candidateCreateForm.get('altemail').setValidators([Validators.required]);
        }

        // alt mobile number
        if (orgBasedCandidateFormsJson.altmobinoFieldIsRequired) {
            candidateCreateForm.get('altermobino').setValidators([Validators.required]);
        }

        // alt mobile number
        if (orgBasedCandidateFormsJson.currentlyEmployedFieldIsActive) {
            candidateCreateForm.get('currentlyemployed').setValidators([Validators.required]);
        }
        //update value and validity 
        candidateCreateForm.updateValueAndValidity();
        return candidateCreateForm;
    }



    //add new education form array
    addNewEducationFormArrayField() {
        return this.formBuilder.group({
            id: new FormControl(null),
            atscandeduid: new FormControl(null),
            degreename: new FormControl('', [Validators.required, Validators.maxLength(70)]),
            specialization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            percent: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
            university: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
            yearofpassing: new FormControl(null, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4),Validators.minLength(4)]),
            type: new FormControl(''),
            status: new FormControl(''),
        });
    }

    //add new education form array with data
    addNewEducationFieldBasedOnData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            atscandeduid: new FormControl(data.atscandeduid),
            degreename: new FormControl(data.degreename, [Validators.required, Validators.maxLength(70)]),
            specialization: new FormControl(data.specialization, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            percent: new FormControl(data.percent, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
            university: new FormControl(data.university, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
            yearofpassing: new FormControl(data.yearofpassing, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4),Validators.minLength(4)]),
            type: new FormControl(data.type),
            status: new FormControl(''),
        });
    }

    //add new education form AI parser
    addNewEducationFieldBasedOnAIData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            atscandeduid: new FormControl(data.atscandeduid),
            degreename: new FormControl(data.name, [Validators.required, Validators.maxLength(70)]),
            specialization: new FormControl(data.specilization, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            percent: new FormControl(data.percentage, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
            university: new FormControl(data.university, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
            yearofpassing: new FormControl(data.yearpassed, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4),Validators.minLength(4)]),
            type: new FormControl(data.type),
            status: new FormControl(''),
        });
    }
    //add new experience form array
    addNewExperienceFormArrayField(data) {
        return this.formBuilder.group({
            id: new FormControl(null),
            atscandexpid: new FormControl(null),
            organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            startdt: new FormControl(''),
            enddt: new FormControl('',[endDateValidator]),
            ctcvalue: new FormControl('', [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
            ctctype: new FormControl(data.preferredcurrency),
            type: new FormControl(''),
            status: new FormControl(''),
        });
    }
    

    //add new experience form array with data
    addNewExperienceFieldBasedOnData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            atscandexpid: new FormControl(data.atscandexpid),
            organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            startdt: new FormControl(data.startdt),
            enddt: new FormControl(data.enddt,[endDateValidator]),
            ctcvalue: new FormControl(data.ctcvalue, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(8)]),
            ctctype: new FormControl(data.ctctype),
            type: new FormControl(data.type),
            status: new FormControl(''),
        });
    }

        //add new experience form AI parser
        addNewExperienceFieldBasedOnAIData(data) {
            return this.formBuilder.group({
                id: new FormControl(data.id),
                atscandexpid: new FormControl(data.atscandexpid),
                organization: new FormControl(data.organisation, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
                designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                startdt: new FormControl(data.startdate),
                enddt: new FormControl(data.enddate,[endDateValidator]),
                ctcvalue: new FormControl(data.ctc, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(8)]),
                ctctype: new FormControl(data.ctctype),
                type: new FormControl(data.type),
                status: new FormControl(''),
            });
        }

    //add new skill form array
    addNewSkillFormArrayField() {
        return this.formBuilder.group({
            id: new FormControl(null),
            atscandskillsid: new FormControl(null),
            skill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            version: new FormControl('', []),
            yrsworked: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(2)]),
            lastused: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
            proficiency: new FormControl('', []),
            status: new FormControl('', []),
        });
    }

    //add new skill form array with data
    addNewSkillFormArrayFieldBasedOnData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            atscandskillsid: new FormControl(data.atscandskillsid),
            skill: new FormControl(data.skill, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            version: new FormControl(data.version, []),
            yrsworked: new FormControl(data.yrsworked, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(2)]),
            lastused: new FormControl(data.lastused, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
            proficiency: new FormControl(data.proficiency, []),
            status: new FormControl('', []),
        });
    }
    //add new skill form AI parser
    addNewSkillFormArrayFieldBasedOnAIData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            atscandskillsid: new FormControl(data.atscandskillsid),
            skill: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            version: new FormControl(data.version, []),
            yrsworked: new FormControl(data.duration, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(2)]),
            lastused: new FormControl(data.lastused, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
            proficiency: new FormControl(data.proficiency, []),
            status: new FormControl('', []),
        });
    }

    //add new relative form array
    addNewRelativeFormArrayField(orgBasedCandidateFormsJson: OrgBasedCandidateForm,dialcode) {
        return this.formBuilder.group({
            name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            // relationship: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            email: new FormControl('', [Validators.required, Validators.email]),
            dialcode: new FormControl(dialcode),
            mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
            mobino: new FormControl(''),
            location: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            department: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        });
    }

    //add new relative form array with data
    addNewRelativeFormArrayFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedCandidateForm, data) {
        if (orgBasedOnboardFormsJson.decrelworkFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                empid: new FormControl(data.empid, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                designation: new FormControl(data.designation, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                email: new FormControl(data.email, [Validators.required, Validators.email]),
                dialcode: new FormControl(''),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
                mobino: new FormControl(data.mobino),
                location: new FormControl(data.location, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                department: new FormControl(data.department, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                empid: new FormControl(data.empid, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                email: new FormControl(data.email, [Validators.email]),
                dialcode: new FormControl(''),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]),
                mobino: new FormControl(data.mobino),
                location: new FormControl(data.location, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                department: new FormControl(data.department, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            });
        }
    }

}